import React, { useState, useEffect, useRef, useContext } from "react";
import styled from "styled-components";
import SubscriberBoxPlot from "./SubscriberBoxPlot";
import ColumnsGrid from "common/layouts/ColumnsGrid";
import Switch from "@mui/material/Switch";

const Wrapper = styled.div`
  margin: 30px 20px 0 20px;
`;

const TotalSubscribers = styled.h4`
  font-size: 16px !important;
  font-weight: 100 !important;
  color: var(--text-primary) !important;
  display: flex;
`;

const WrapperTotalColorize = styled.div`
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
`;

const WrapperSwitch = styled.div`
  display: flex;
  align-items: center;
  .sw-input.MuiSwitch-root {
    & .Mui-checked {
      color: var(--switch-checked-green);
    }

    & .Mui-checked + .MuiSwitch-track {
      background-color: var(--switch-checked-light-green);
    }
  }
`;

const NoEnoughtData = () => (
  <CenteredMessage>Not enough data to display box plots.</CenteredMessage>
);

const BOXPLOT_METRICS_ORDER_MAP = {
  "MAX-Mbps": 0,
  "RTT-ms": 1,
  RTX: 2,
  "MAX-SPEED": 3,
  CONGEST: 4,
};

const Statistics = ({
  data,
  colorize,
  setColorize,
  thresholds,
  setThresholds,
  ...settings
}) => {
  const totalSubs = data.rows ? data.rows.length : 0;

  const statisticsMetrics = Object.entries(data)
    .filter(([key, value]) => {
      return key !== "rows";
    })
    .sort(
      (a, b) =>
        BOXPLOT_METRICS_ORDER_MAP[a[0]] - BOXPLOT_METRICS_ORDER_MAP[b[0]]
    );

  const handleUpdateThresholds = (metric, value) => {
    const cmd = `configure\npkteng\nmetrics threshold ${metric.toLowerCase()} ${value}\ncommit\n`;
    ifCl
      .run(cmd, true)
      .then(() => setThresholds({ ...thresholds, [metric]: value }))
      .catch((error) => showModalError("Error:", error));
  };

  return (
    <Wrapper>
      <WrapperTotalColorize>
        <TotalSubscribers>{totalSubs} active subscribers</TotalSubscribers>
        <WrapperSwitch>
          <div>
            {!colorize
              ? "Colorize: by warning threshold"
              : "Colorize: by quartiles"}
          </div>
          <Switch
            className="sw-input"
            checked={colorize}
            onChange={() => setColorize(!colorize)}
          />
        </WrapperSwitch>
      </WrapperTotalColorize>
      {data.totalGroups < 2 ? (
        <NoEnoughtData />
      ) : (
        <ColumnsGrid
          columns={statisticsMetrics.length}
          minWidth="5cm"
          gap={"2em"}
          className="box-plot-container"
          rowGap="0"
        >
          {statisticsMetrics.map(([key, values]) => {
            return (
              <SubscriberBoxPlot
                metric={key}
                data={values}
                threshold={thresholds[key]}
                updateThresholds={handleUpdateThresholds}
                colorize={colorize}
                key={`box-plot-${key}`}
              />
            );
          })}
        </ColumnsGrid>
      )}
    </Wrapper>
  );
};

export default Statistics;